import React from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import landingPageImg from '../../../../assets/purchase-yearbooks-landing-page.jpg';
import Image from '../../../Image';

export default function StudentPromoImage({ studentId, campaign = 'yearbooks' }) {
  const { data, isLoading } = useQuery({
    queryKey: ['promo image', campaign, studentId],
    queryFn: () => (
      axios({
        method: 'GET',
        url: 'promotional_images/student_promo_image',
        baseURL: '/',
        params: { student_id: studentId, campaign },
      })
        .then((res) => res.data.data)
    ),
  });

  if (isLoading) return null;
  if (!data || Object.keys(data).length === 0) return <Image src={landingPageImg} alt="Purchase Yearbooks Image" />;

  return (
    <img alt="Promo" src={data.imageUrl} style={{ maxWidth: '100%', height: 'auto' }} />
  );
}
